import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiltersState } from "./type";

const initialState: FiltersState = {
  fromDate: null,
  toDate: null,
  paymentDate: null,
  filterGenerated: false, 
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<Date | null>) {
      state.toDate = action.payload;
    },
    setPaymentDate(state, action: PayloadAction<Date | null>) {
      state.paymentDate = action.payload;
    },
    setFilterGenerated(state, action: PayloadAction<boolean>) {
      state.filterGenerated = action.payload;
    },
  },
});

export const { setFromDate, setToDate, setPaymentDate, setFilterGenerated } = filtersSlice.actions;
export default filtersSlice.reducer;
